"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _OrderQuestionInput = _interopRequireDefault(require("./OrderQuestionInput.js"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _OrderQuestionModule = _interopRequireDefault(require("./OrderQuestion.module.scss"));
var _material = require("@heron-web/material");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Render's a single order question
 * 
 * @package HOPS
 * @subpackage OrderQuestions
 * @author Heron Web Ltd
 * @copyright Heritage Operations Processing Limited
 */
class OrderQuestion extends _react.default.PureComponent {
  /**
   * Render.
   * 
   * @return {ReactNode}
   */
  render() {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Flex, {
      gap: 0.5,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.String, {
        bold: true,
        str: this.props.question.Body
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_OrderQuestionInput.default, {
        color: this.props.color,
        disabled: this.props.hasOptionalNoAnswerAcknowledgement,
        id: this.props.id,
        onChange: this.props.onChange,
        options: this.props.question.Options,
        required: this.props.required,
        type: this.props.question.DataType,
        value: this.props.answerValue
      }), !this.props.required && this.props.requireOptionalNoAnswerAcknowledgement && this.renderAcknowledgement()]
    });
  }

  /**
   * Render the "acknowledgement" button.
   *
   * Provides an explicit "I'm not answering" control for optional questions.
   * 
   * @return {ReactNode}
   */
  renderAcknowledgement() {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Flex, {
      alignItems: "center",
      columnar: true,
      flexWrap: true,
      gap: 0.5,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Checkbox, {
        checked: this.props.hasOptionalNoAnswerAcknowledgement,
        name: this.props.id,
        onChange: this.props.onChangeOptionalNoAnswerAcknowledgement,
        required: !this.props.answerValue
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.String, {
        classNameTypography: _OrderQuestionModule.default.acknowledgement,
        str: "I'm not answering this question."
      })]
    });
  }
  static propTypes = {
    color: _propTypes.default.oneOf(["primary", "secondary"]),
    answerValue: _propTypes.default.any,
    hasOptionalNoAnswerAcknowledgement: _propTypes.default.bool,
    id: _propTypes.default.string,
    onChange: _propTypes.default.func,
    onChangeOptionalNoAnswerAcknowledgement: _propTypes.default.func,
    question: _propTypes.default.object,
    required: _propTypes.default.bool,
    requireOptionalNoAnswerAcknowledgement: _propTypes.default.bool
  };
  static defaultProps = {
    answerValue: null,
    color: "primary",
    hasOptionalNoAnswerAcknowledgement: false,
    required: false,
    requireOptionalNoAnswerAcknowledgement: false
  };
}
var _default = OrderQuestion;
exports.default = _default;